import { render, staticRenderFns } from "./CartTable.vue?vue&type=template&id=2c3c1c68&scoped=true"
import script from "./CartTable.vue?vue&type=script&lang=ts"
export * from "./CartTable.vue?vue&type=script&lang=ts"
import style0 from "./CartTable.vue?vue&type=style&index=0&id=2c3c1c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c1c68",
  null
  
)

export default component.exports